import { useMemo } from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { CHART_COLORS, flattenRegionalDistricts, formatChartTooltipValue } from '../../chartUtils';
import { useRegionalNurseryDistributionQuery } from '../../hooks/useDashboardAnalytics';
import { ChartCard } from './ChartCard';

export function RegionalNurseryDistributionChart() {
  const { data, isLoading, errorMessage } = useRegionalNurseryDistributionQuery();
  const chartData = useMemo(() => flattenRegionalDistricts(data ?? null), [data]);

  return (
    <ChartCard
      title="District-wise Nursery Distribution"
      subtitle="Active nurseries · Permits issued"
      loading={isLoading}
      error={errorMessage}
      minHeight={360}
    >
      {chartData.length > 0 ? (
        <ResponsiveContainer width="100%" height={360}>
          <BarChart
            data={chartData}
            layout="vertical"
            margin={{ top: 8, right: 24, left: 8, bottom: 8 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis type="number" />
            <YAxis type="category" dataKey="districtName" width={110} tick={{ fontSize: 12 }} />
            <Tooltip formatter={(value) => formatChartTooltipValue(value)} />
            <Legend />
            <Bar
              dataKey="applicationsSubmitted"
              name="Active Nurseries"
              fill={CHART_COLORS.forestGreen}
              radius={[0, 4, 4, 0]}
            />
            <Bar
              dataKey="permitsIssued"
              name="Permits Issued"
              fill={CHART_COLORS.gold}
              radius={[0, 4, 4, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      ) : null}
    </ChartCard>
  );
}
